import * as React from "react";
const SvgForwardFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 6a2 2 0 0 1 1.2.4l5.334 4a2 2 0 0 1 0 3.2l-5.334 4A2 2 0 0 1 11 16v-1.25L7.2 17.6A2 2 0 0 1 4 16V8a2 2 0 0 1 3.2-1.6L11 9.25V8a2 2 0 0 1 2-2", clipRule: "evenodd" }));
export default SvgForwardFill;
